<div>
  <div class="summary-group">
    <div class="summary-title">{{'tasks.loan_detail' | translate | uppercase}}</div>
  </div>
  @if (loan) {
    <div class="overflow-y-auto overflow-x-hidden">
      <div class="field grid row">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="field grid row hrBottom">
          <div class="row">
            <div class="col">
              <span class="sub-title-label" translate>loans.amount<span>:</span></span>
            </div>
            <div class="col">
              <span class="value-label">{{formatNumber(loan.totalAmount) || 0}} {{loan.currency}}</span>
            </div>
          </div>
            <div class="row">
                <div class="col">
                    <ng-container *ngIf="showCustomerLink; else plainLabel">
                        <a [attr.href]="loan.customerSpecificOptions?.[0]?.customerId ? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId+'?agrNum='+loan.agreementNumber+(loan.id ? '&loanId='+loan.id : '') : null">
        <span class="sub-title-label"
              [pTooltip]="loan.customerSpecificOptions?.[0]?.customerId ? ('message.go_loans_page' | translate) : null"
              tooltipStyleClass="tooltip-class" tooltipPosition="left"
              translate>accounts.agreement_number<span>:</span></span>
                        </a>
                    </ng-container>
                    <ng-template #plainLabel>
                        <span class="sub-title-label" translate>accounts.agreement_number<span>:</span></span>
                    </ng-template>
                </div>
                <div class="col">
                    <ng-container *ngIf="showCustomerLink; else plainValue">
                        <a [attr.href]="loan.customerSpecificOptions?.[0]?.customerId ? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId+'?agrNum='+loan.agreementNumber+(loan.id ? '&loanId='+loan.id : '') : null">
        <span class="value-label"
              [pTooltip]="loan.customerSpecificOptions?.[0]?.customerId ? ('message.go_loans_page' | translate) : null"
              tooltipStyleClass="tooltip-class"
              tooltipPosition="left">{{loan.agreementNumber}}</span>
                        </a>
                    </ng-container>
                    <ng-template #plainValue>
                        <span class="value-label">{{loan.agreementNumber}}</span>
                    </ng-template>
                </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>summary.agr_date<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.startDate}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>common.status<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{formatTextCapitalize(loan.status) || 'N/A'}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>loans.product_name<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.loanTemplateName}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>product.id<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.productId}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>product.description<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{loan.loanTemplateDescription}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <span class="sub-title-label" translate>tasks.group_id<span>:</span></span>
              </div>
              <div class="col">
                <span class="value-label">{{customerGroupId ||  'N/A'}}</span>
              </div>
            </div>
            <div class="row">
                <div class="col">
                    <ng-container *ngIf="showCustomerLink; else plainCustomerLabel">
                        <a [attr.href]="loan.customerSpecificOptions?.[0]?.customerId ? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId : null">
        <span class="sub-title-label"
              [pTooltip]="loan.customerSpecificOptions?.[0]?.customerId ? ('message.go_customer_page' | translate) : null"
              tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>customer_mngt.customer_id</span>:</span>
                        </a>
                    </ng-container>
                    <ng-template #plainCustomerLabel>
                        <span class="sub-title-label"><span translate>customer_mngt.customer_id</span>:</span>
                    </ng-template>
                </div>
                <div class="col">
                    <ng-container *ngIf="showCustomerLink; else plainCustomerNumber">
                        <a [attr.href]="loan.customerSpecificOptions?.[0]?.customerId ? '/user/customers/view/'+loan.customerSpecificOptions[0].customerId : null">
        <span class="value-label"
              [pTooltip]="loan.customerSpecificOptions?.[0]?.customerId ? ('message.go_customer_page' | translate) : null"
              tooltipStyleClass="tooltip-class"
              tooltipPosition="left">{{loan.customerSpecificOptions[0].customerNumber}}</span>
                        </a>
                    </ng-container>
                    <ng-template #plainCustomerNumber>
                        <span class="value-label">{{loan.customerSpecificOptions[0].customerNumber}}</span>
                    </ng-template>
                </div>
            </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loan_customer_name<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.customerSpecificOptions[0].customerFullName}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>common.attached_files<span>:</span></span>
                </div>
                <div class="col">
                  @if (loanFiles?.length) {
                    <div class="flex flex-column">
                      <span class="value-label flex gap-2">
                        @for (file of loanFiles; track file.id || $index; let i = $index) {
                          <img (click)="openFile(i)" src="assets/img/image_document.svg" width="16"
                            [pTooltip]="file.title"
                            tooltipPosition="top"
                            alt="imageView"
                            class="cursor-pointer">
                        }
                      </span>
                      <p-galleria
                        [(value)]="loanFiles"
                        [(visible)]="displayBasic"
                        [containerStyle]="{'max-width': '50%'}"
                        [circular]="false"
                        [fullScreen]="true"
                        [showItemNavigators]="true"
                        [showThumbnails]="false"
                        [showIndicators]="true"
                        [showIndicatorsOnItem]="false"
                        [(activeIndex)]="activeIndex">
                        <ng-template pTemplate="item" let-item>
                          <img [src]="item.itemImageSrc" alt=""
                            (error)="item.itemImageSrc = 'assets/img/document-default.png'"
                            class="document-preview-image"/>
                        </ng-template>
                        <ng-template pTemplate="caption" let-item>
                          <p>{{ item.title }}</p>
                          <button (click)="downloadFile(item)" pButton translate>buttons.download</button>
                        </ng-template>
                      </p-galleria>
                    </div>
                  } @else {
                    <span class="value-label">—</span>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="field grid row">
            <div class="row">
              <div class="col">
                <span class="title-label">{{'collaterals.outstanding_amounts'| translate | uppercase}}</span>
              </div>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.outstanding_amount<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.calculated_interest<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingInterestAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.calculated_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingServiceFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.outstanding_late_payment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingLateRepaymentFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.outstanding_interest_late_payment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingInterestLateRepaymentFeeAmount) || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.loans.service_fee_late_payment_outstanding_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatNumber(loan.outstandingSummary?.outstandingServiceFeeLatePaymentFeeAmount) ||0}} {{loan.currency}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="title-label">{{'summary.loans.loan_parameters' | translate | uppercase}}</span>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>common.period<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loanPeriodCovertToString()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>summary.interest_rate<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.interestRate}}%</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.agreement_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.startDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.granting_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.grantingDate || '—'}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.first_payment_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.firstRepaymentDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.interest_calculate_opt<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{findInterestCalculationOptions(loan.interestCalculationOption)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.maturity_date<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.maturityDate}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.maturity_type<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{formatUppercaseText(loan.maturityType)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.auto_direct_debit_indicator<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.autoDirectDebitIndicator ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.early_repayment<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.earlyRepayment ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.early_repayment_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.earlyRepaymentFee ? "Yes" : "No"}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLoanServiceFeeAmount()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_pricipal<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeePrincipal()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_interest<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeeInterest()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <span class="sub-title-label" translate>loans.late_payment_fee_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getLatePaymentFeeServicefee()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontFee()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_vat<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontVAT()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_stamp_duty<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontStampDuty()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_disaster_recovery<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontDisasterRecovery()}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loans.upfront_service_fee<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{getUpfrontServiceFee()}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="field grid row">
            <div class="row">
              <div class="col">
                <span class="title-label">{{'risks.classification-provisioning' | translate | uppercase}}</span>
              </div>
            </div>
            <div class="field grid row hrBottom">
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>risks.risk-classification-code<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.riskCategory || 'N/A'}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loan-provision.amount<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan?.provisionAmount || 0}} {{loan.currency}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col padding-item">
                  <span class="sub-title-label" translate>loan-provision.percentage<span>:</span></span>
                </div>
                <div class="col">
                  <span class="value-label">{{loan.provisioningRate ? loan.provisioningRate + '%' : 'N/A'}}</span>
                </div>
              </div>
            </div>
          </div>
          @if ((collaterals && collaterals.length > 0) || (guarantees && guarantees.length > 0) || loan?.securityRequirementsEnabled) {
            <div class="field grid row">
              <div class="row">
                <div class="col">
                  <span class="title-label">{{'loans.security' | translate | uppercase}}</span>
                </div>
              </div>
              
              <div class="field grid row hrBottom">
                @if (loan?.securityRequirementsEnabled) {
                  @if (loan.collateralCoverage != null) {
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>loans.collateral_coverage<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{loan.collateralCoverage}}%</span>
                      </div>
                    </div>
                  }
                  @if (loan.guaranteeCoverage != null) {
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>loans.guarantee_coverage<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{loan.guaranteeCoverage}}%</span>
                      </div>
                    </div>
                  }
                  @if (loan.totalCoverage != null) {
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>loans.total_coverage<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{loan.totalCoverage}}%</span>
                      </div>
                    </div>
                  }
                  @if (loan.minNumberOfGuarantors != null) {
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>loans.min_number_of_guarantors<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{loan.minNumberOfGuarantors}}</span>
                      </div>
                    </div>
                  }
                }
                @if (collaterals && collaterals.length > 0) {
                  @for (item of collaterals; track item; let i = $index) {
                  <div class="field grid row">
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label">
                          <strong>{{'tasks.collateral' | translate}} {{i + 1}}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <a [attr.href]="item.providerId ? '/user/customers/view/' + item.providerId + '?agrNum=' + item.collateralAgreementNumber : null">
                          <span class="sub-title-label"
                            [pTooltip]="('message.go_collaterals_page' | translate)"
                            tooltipStyleClass="tooltip-class" tooltipPosition="left"
                            translate>accounts.agreement_number<span>:</span></span>
                        </a>
                      </div>
                      <div class="col">
                        <a [attr.href]="item.providerId ? '/user/customers/view/' + item.providerId + '?agrNum=' + item.collateralAgreementNumber : null">
                          <span class="value-label"
                            [pTooltip]="('message.go_collaterals_page' | translate)"
                            tooltipStyleClass="tooltip-class"
                            tooltipPosition="left">{{item.collateralAgreementNumber}}</span>
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <a [attr.href]="getProviderCustomerUrl(item)"
                           [class.cursor-pointer]="isProviderSameAsLoanCustomer(item)"
                           (click)="onProviderClick(item)">
                          <span class="sub-title-label"
                            [pTooltip]="('message.go_customer_page' | translate)"
                            tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>summary.provider_id</span>:</span>
                        </a>
                      </div>
                      <div class="col">
                        <a [attr.href]="getProviderCustomerUrl(item)"
                           [class.cursor-pointer]="isProviderSameAsLoanCustomer(item)"
                           (click)="onProviderClick(item)">
                          <span class="value-label"
                            [pTooltip]="('message.go_customer_page' | translate)"
                            tooltipStyleClass="tooltip-class"
                            tooltipPosition="left">{{item.providerNumber}}</span>
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>summary.provider_name<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{item.providerFullName}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>common.amount<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{item.amount}}</span>
                      </div>
                    </div>
                  </div>
                  }
                }
                @if (guarantees && guarantees.length > 0) {
                  @for (item of guarantees; track item; let i = $index) {
                  <div class="field grid row">
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label">
                          <strong>{{'tasks.guarantee' | translate}} {{i + 1}}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <a [attr.href]="item.guarantorId ? '/user/customers/view/' + item.guarantorId + '?agrNum=' + item.guaranteeAgreementNumber : null">
                          <span class="sub-title-label"
                            [pTooltip]="('message.go_guarantees_page' | translate)"
                            tooltipStyleClass="tooltip-class" tooltipPosition="left"
                            translate>accounts.agreement_number<span>:</span></span>
                        </a>
                      </div>
                      <div class="col">
                        <a [attr.href]="item.guarantorId ? '/user/customers/view/' + item.guarantorId + '?agrNum=' + item.guaranteeAgreementNumber : null">
                          <span class="value-label"
                            [pTooltip]="('message.go_guarantees_page' | translate)"
                            tooltipStyleClass="tooltip-class"
                            tooltipPosition="left">{{item.guaranteeAgreementNumber}}</span>
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <a [attr.href]="getGuarantorCustomerUrl(item)"
                           [class.cursor-pointer]="isGuarantorSameAsLoanCustomer(item)"
                           (click)="onGuarantorClick(item)">
                          <span class="sub-title-label"
                            [pTooltip]="('message.go_customer_page' | translate)"
                            tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>guarantee.guarantor_id</span>:</span>
                        </a>
                      </div>
                      <div class="col">
                        <a [attr.href]="getGuarantorCustomerUrl(item)"
                           [class.cursor-pointer]="isGuarantorSameAsLoanCustomer(item)"
                           (click)="onGuarantorClick(item)">
                          <span class="value-label"
                            [pTooltip]="('message.go_customer_page' | translate)"
                            tooltipStyleClass="tooltip-class"
                            tooltipPosition="left">{{item.guarantorNumber}}</span>
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>guarantee.guarantor_name<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{item.guarantorFullName}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col padding-item">
                        <span class="sub-title-label" translate>common.amount<span>:</span></span>
                      </div>
                      <div class="col">
                        <span class="value-label">{{item.amount}}</span>
                      </div>
                    </div>
                  </div>
                  }
                }
              </div>
            </div>
          }
          @if (loan.linkedAccount) {
            <div class="field grid row">
              <div class="row">
                <div class="col">
                  <span class="title-label">{{'linked_accounts.title' | translate | uppercase}} </span>
                </div>
                <div class="field grid row hrBottom">
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.account<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions?.[0]?.grantingAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.correspond_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions[0].correspondentAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_correspond_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.customerSpecificOptions[0].interestCorrespondentAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>accounts.interest_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestLatePaymentFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.interest_late_payment_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.interestLatePaymentFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeLatePaymentFeeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.service_late_payment_fee_income_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.serviceFeeLatePaymentFeeIncomeAccountNumber || '—'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>loans.late_payment_fee_acc<span>:</span></span>
                    </div>
                    <div class="col pl-30">
                      <span class="value-label">{{loan.linkedAccount.lateRepaymentFeeAccountNumber || '—' }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label"
                        translate>loans.late_payment_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.lateRepaymentFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.early_fee_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.earlyRepaymentFeeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.early_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.earlyRepaymentFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.upfrontFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_vat_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.upfrontVATIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_stamp_duty_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.upfrontStampDutyIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_disaster_recovery_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.upfrontDisasterRecoveryIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="sub-title-label" translate>loans.upfront_service_fee_income_acc<span>:</span></span>
                      </div>
                      <div class="col pl-30">
                        <span class="value-label">{{loan.linkedAccount.serviceUpfrontFeeIncomeAccountNumber || '—'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (loan.notes?.length > 0) {
              <div class="field grid row">
                <div class="row">
                  <div class="col">
                    <span class="title-label">{{'common.notes' | translate | uppercase}}</span>
                  </div>
                  <div class="field grid row hrBottom">
                    @for (note of notesHierarchy; track note) {
                      <div class="row">
                        <div class="col">
                          <span class="sub-title-label">{{note.parent}}:</span>
                        </div>
                        <div class="col pl-30">
                          <span class="value-label"> {{note.child}}</span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <div class="field grid row">
              <div class="row">
                <div class="col">
                  <div class="title-label">{{'common.add_info' | translate | uppercase}}</div>
                </div>
              </div>
              <div class="field grid row hrBottom">
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>summary.loans.loan_description<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.description || '—'}}</span>
                  </div>
                </div>
                @if (loan.closeDate) {
                  <div class="row">
                    <div class="col padding-item">
                      <span class="sub-title-label" translate>common.close_date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.closeDate}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col padding-item">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchName(loan.branchId)}}</span>
                  </div>
                </div>
              </div>
            </div>
            @if (loan && loan.upfrontFeeChargingOp) {
              <div class="field grid row hrBottom">
                <div class="row">
                  <span class="sub-title-label">{{'loans.upfront_fee' | translate | uppercase}}</span>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>orders.document_number<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.upfrontFeeChargingOp.documentNumber}}</span>
                  </div>
                </div>
                @if (loan.upfrontFee) {
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>common.date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.upfrontFeeChargingOp.date}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.amount<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{formatNumber(loan.upfrontFeeChargingOp.amount)}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>loans.upfront_fee_charge<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.upfrontFeeChargingOp.chargingType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchNameFromCode(loan.upfrontFeeChargingOp.branchCode)}}</span>
                  </div>
                </div>
              </div>
            }
            @for (charge of [
              { type: 'UPFRONT_VAT', label: 'loans.upfront_vat' },
              { type: 'UPFRONT_STAMP_DUTY', label: 'loans.upfront_stamp_duty' },
              { type: 'UPFRONT_DISASTER_RECOVERY', label: 'loans.upfront_disaster_recovery' }
            ]; track charge.type) {
              @if (upfrontChargeOperation(charge.type); as operation) {
                <div class="field grid row hrBottom">
                  <div class="row"><span class="sub-title-label">{{ charge.label | translate | uppercase }}</span></div>
                  <div class="row"><div class="col"><span class="sub-title-label" translate>orders.document_number<span>:</span></span></div><div class="col"><span class="value-label">{{operation.documentNumber}}</span></div></div>
                  <div class="row"><div class="col"><span class="sub-title-label" translate>common.date<span>:</span></span></div><div class="col"><span class="value-label">{{operation.date}}</span></div></div>
                  <div class="row"><div class="col"><span class="sub-title-label" translate>common.amount<span>:</span></span></div><div class="col"><span class="value-label">{{formatNumber(operation.amount)}}</span></div></div>
                  <div class="row"><div class="col"><span class="sub-title-label" translate>common.branch<span>:</span></span></div><div class="col"><span class="value-label">{{getBranchNameFromCode(operation.branchCode)}}</span></div></div>
                </div>
              }
            }
            @if (loan && loan.grantingOp) {
              <div class="field grid row hrBottom">
                <div class="row">
                  <span class="sub-title-label">{{'loans.granting' | translate | uppercase}}</span>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>orders.document_number<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.grantingOp.documentNumber}}</span>
                  </div>
                </div>
                @if (loan.grantingOp) {
                  <div class="row">
                    <div class="col">
                      <span class="sub-title-label" translate>common.date<span>:</span></span>
                    </div>
                    <div class="col">
                      <span class="value-label">{{loan.grantingOp.date}}</span>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.amount<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{formatNumber(loan.grantingOp.amount)}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>loans.granting<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{loan.grantingOp.grantingType}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span class="sub-title-label" translate>common.branch<span>:</span></span>
                  </div>
                  <div class="col">
                    <span class="value-label">{{getBranchName(loan.grantingOp.branchId)}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
